import { hasSelectionInBlockGroup } from './hasSelectionInBlockGroup';
import { hasSelectionInSegment } from './hasSelectionInSegment';
import type { ReadonlyContentModelBlock } from 'roosterjs-content-model-types';

/**
 * Check if there is selection within the given block
 * @param block The block to check
 */
export function hasSelectionInBlock(block: ReadonlyContentModelBlock): boolean {
    switch (block.blockType) {
        case 'Paragraph':
            return block.segments.some(hasSelectionInSegment);

        case 'Table':
            return block.rows.some(row => row.cells.some(hasSelectionInBlockGroup));

        case 'BlockGroup':
            return hasSelectionInBlockGroup(block);

        case 'Divider':
        case 'Entity':
            return !!block.isSelected;

        default:
            return false;
    }
}
